import { IDocumentState } from '@/store/document';
import { IDocumentGetters } from './getters.types';
import {
  IDocumentRevision,
  IQuoteDocumentTag,
  IQuoteProductDocument,
  QuoteDocumentTag,
  QuoteProductDocument
} from '@/models';
import { DocumentRevision } from '@/models/document/document';

export const getters: IDocumentGetters = {
  getDocumentCount(state: IDocumentState): number {
    return state.count;
  },

  getQuoteProductDocuments(state: IDocumentState): IQuoteProductDocument[] {
    return state.documents.map(data => new QuoteProductDocument(data));
  },

  getQuoteProductDocumentById: (state: IDocumentState) => (
    id: number
  ): IQuoteProductDocument | undefined => {
    const data = state.documents.find(document => document.id === id);
    if (!data) {
      return undefined;
    }

    return new QuoteProductDocument(data);
  },

  getLatestQuoteProductDocument(state: IDocumentState): IQuoteProductDocument {
    const data = state.documents[state.documents.length - 1];
    return new QuoteProductDocument(data);
  },

  getDocumentRevisions(state: IDocumentState): IDocumentRevision[] {
    return state.documentRevisions.map(
      revision => new DocumentRevision(revision)
    );
  },

  //Tags
  getQuoteDocumentTags(state: IDocumentState): IQuoteDocumentTag[] {
    return state.documentTags.map(data => new QuoteDocumentTag(data));
  },

  getQuoteDocumentTagById: (state: IDocumentState) => (
    id: number
  ): IQuoteDocumentTag | undefined => {
    const data = state.documentTags.find(tag => tag.id === id);
    if (!data) {
      return undefined;
    }

    return new QuoteDocumentTag(data);
  },

  getLatestQuoteDocumentTag(state: IDocumentState): IQuoteDocumentTag {
    const data = state.documentTags[state.documentTags.length - 1];
    return new QuoteDocumentTag(data);
  }
};
